interface Props {
  /** Override the displayed label. Default: "AI". */
  label?: string;
  /** Optional descriptor for screen readers and a hover title. */
  title?: string;
}

/**
 * Discreet badge marking a surface that runs through a model: forecast,
 * regression, classification, clustering, or NLP. Statistical aggregates,
 * z-score thresholds, and drift-vs-baseline checks do NOT qualify.
 */
export default function AiBadge({ label = "AI", title = "Model-derived: forecast, classification, regression, or NLP" }: Props) {
  return (
    <span className="ai-badge" title={title} aria-label={title}>
      <svg
        className="ai-badge-icon"
        width="9"
        height="9"
        viewBox="0 0 10 10"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M5 0.75l1 2.25 2.25 1L6 5l-1 2.25-1-2.25L1.75 4 4 3l1-2.25z"
          fill="currentColor"
        />
        <circle cx="8.5" cy="1.5" r="0.7" fill="currentColor" />
        <circle cx="1.5" cy="8.5" r="0.7" fill="currentColor" />
      </svg>
      <span className="ai-badge-text">{label}</span>
    </span>
  );
}
